module.exports = __webpack_public_path__ + "img/complaint-default.09e518eb.png";